"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
/* tslint:disable: no-bitwise */
function dashify(val) {
    return val && val.length === 32
        ? val.replace(/([0-9a-f]{8})([0-9a-f]{4})([0-9a-f]{4})([0-9a-f]{4})([0-9a-f]{12})/, '$1-$2-$3-$4-$5')
        : val;
}
exports.dashify = dashify;
function removeDashes(id) {
    return id ? id.replace(/-/g, '') : id;
}
exports.removeDashes = removeDashes;
exports.guid = function () {
    var id = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line
        var r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
    return id;
};
function xor(str, key) {
    if (!str || !key) {
        return null;
    }
    return lodash_1.zip(str.split(''), key.split('')).reduce(function (acc, _a) {
        var _b = tslib_1.__read(_a, 2), aStr = _b[0], bStr = _b[1];
        var a = parseInt(aStr, 16);
        var b = parseInt(bStr, 16);
        if (!isNaN(a) && !isNaN(b)) {
            return acc + (a ^ b).toString(16); // eslint-disable-line no-bitwise
        }
        return acc + "-";
    }, '');
}
exports.xor = xor;
//# sourceMappingURL=guid.js.map